import { connect } from 'react-redux';
import { lifecycle, compose, withProps, withState } from 'recompose';
import EditShop from '../components/editShop';
import { getShop } from '../reducers';
import withNotifications from '../../../common/withNotifications';
import { fetchShop, fetchShopLdFlags, updateAdminShop } from '../actions';
import withAdminShopUser from '../../hoc/withAdminShopUser';
import { getIsAdminRole } from '../../../auth/selectors';

const mapStateToProps = (state, props) => ({
  shop: getShop(state, props.params.id),
  isAdminView: getIsAdminRole(state),
});

const mapDispatchToProps = {
  updateShop: updateAdminShop,
  fetchShop,
  fetchShopLdFlags,
};

export default compose(
  withProps((ownerProps) => ({
    shopId: ownerProps.params.id,
  })),
  withState('shopLdFlags', 'setShopLdFlags', () => ({})),
  withAdminShopUser,
  connect(mapStateToProps, mapDispatchToProps),
  withNotifications,
  lifecycle({
    componentDidMount() {
      if (this.props.isAdminView) {
        this.props.fetchShopLdFlags(this.props.shopId).then((flags) => {
          this.props.setShopLdFlags(flags);
        });
      } else {
        this.props.setShopLdFlags({});
      }
      this.props.fetchShop(this.props.shopId);
    },
  })
)(EditShop);
